// src/pages/subs.ts —— 06 A-03 下级分销商（列 / 详情 / 主操作 / 不可新增提示条 / 行内与详情写动作）
// 0045 代理加价定价：列表与详情去费率；「调整费率」改为「查看售价」（只读弹层，代理不能改下级售价）
import { askDelete, openNewSub, openSubPrices, openSubPwd, toggleSub } from '../domains/subs';
import { str } from '../domains/types';
import type { SubAgentRow } from '../types';
import { usdt, when } from './lists';
import type { PageDef } from './types';

// 06 A-03 主操作：/me.can_create_sub=false 时隐藏「新增下级」并显示中性提示条（G-11 / X-09；服务端兜底 1305）。
// 2026-10-18 起代理端不展示层级：不再按 level 判定；/me 尚未返回时不出提示条（与旧口径一致，服务端 1305 兜底）
const noSub = (canCreate: boolean | undefined): boolean => canCreate === false;

export const subsPage: PageDef<SubAgentRow> = {
  page: 'subs',
  route: 'GET /api/agent/sub-agents',
  echo: '/agent/sub-agents',
  csvName: 'subs',
  tabs: ['', 'active', 'disabled'],
  tabLabelKey: 'tabSubs',
  tabParam: 'status',
  // 06 A-00：页签已承担 status 过滤，工具条不再渲染 status 下拉 → 状态列不标 facet
  cols: [{ label: 'cSub' }, { label: 'cUsers' }, { label: 'cEarned' }, { label: 'cJoined', sortKey: 'created_at' }, { label: 'cStatus' }],
  cells(ctx, r) {
    const t = ctx.t;
    return [
      { v: `${r.name} · ${r.biz_no}`, sub: r.email },
      { v: String(r.user_count) },
      { v: usdt(r.earned) },
      { v: when(ctx, r.created_at) },
      r.status === 'active' ? { v: str(t, 'stActive'), chip: 'green' } : { v: str(t, 'stDisabled'), chip: 'gray' },
    ];
  },
  detail(ctx, r) {
    const t = ctx.t;
    return {
      title: `${r.name} · ${r.biz_no}`,
      fields: [
        { k: str(t, 'cSub'), v: r.name },
        { k: 'Telegram', v: '—' }, // SubAgentRow 无 telegram_username（J-15）
        { k: str(t, 'refCode'), v: r.code },
        { k: str(t, 'cEarned'), v: usdt(r.earned) },
        { k: str(t, 'cJoined'), v: when(ctx, r.created_at) },
      ],
      // 06 A-03 详情弹层动作：重置密码 / 查看售价（绿色主按钮，0045）
      actions: [
        { label: str(t, 'aSubPwd'), run: (c) => openSubPwd(c, r) },
        { label: str(t, 'aSubPrices'), kind: 'green', run: (c) => void openSubPrices(c, r) },
      ],
    };
  },
  // 06 A-03 统计卡：仅「下级分销商总数」= 列表 total（GAP-01 / GAP-02）
  stats: (ctx, total) => [{ label: str(ctx.t, 'kSubs'), value: String(total), sub: str(ctx.t, 'subs'), dark: true }],
  primary: (ctx) => (noSub(ctx.s.sh.me?.can_create_sub) ? null : { label: str(ctx.t, 'newSub'), run: (c) => openNewSub(c) }),
  tip: (ctx) => (noSub(ctx.s.sh.me?.can_create_sub) ? str(ctx.t, 'noSubTip') : ''),
  actions(ctx, r) {
    const t = ctx.t;
    // 原型 L329–L331 act() 顺序：调整费率（0045 改查看售价）/ 重置密码 / 停用｜启用 / 删除（红）
    return [
      { label: str(t, 'aSubPrices'), run: (c) => void openSubPrices(c, r) },
      { label: str(t, 'aSubPwd'), run: (c) => openSubPwd(c, r) },
      { label: str(t, r.status === 'active' ? 'aDisable' : 'aEnable'), danger: r.status === 'active', run: (c) => void toggleSub(c, r) },
      { label: str(t, 'aDelete'), danger: true, run: (c) => askDelete(c, r) },
    ];
  },
};
